import React from "react";

function CategoryButton({ url, title, color }) {
  return (
    <a className="category-button" href={url} style={{ borderColor: color }}>
      {title}
    </a>
  );
}

export default CategoryButton;
